export default {
  buttons: {
    save: 'Speichern',
  },
  error_messages: {
    product_unavailable: 'Ausverkauft!',
    missing_fields: 'Bitte wähle alle erforderlichen Felder aus',
  },
};
